import styled from 'styled-components';

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: ${props => props.visible ? 0 : 101}%;
  width: ${props => props.visible ? 100 : 0}vw;
  height: 100vh;
  overflow: hidden;
  pointer-events: none;
`;

export const InputWrap = styled.div`
  position: absolute;
  top: ${props => props.position.top}px;
  left: ${props => props.position.left}px;
  transform: translate(-50%, -50%);
`;

export const TextInput = styled.textarea`
  border: none;
  background-color: transparent;
  font-family: ${props => (props.fontName ? props.fontName : '')};
  font-size: 16px;
  color: #000000;
  outline: none;
  resize: none;
  overflow: hidden;
  white-space: nowrap;
`;

export const InputWrapDiv = styled.div`
  position: absolute;
  top: ${props => props.position.top}px;
  left: ${props => props.position.left}px;
  max-width: ${props => props.position.maxWidth}px;
  max-height: ${props => props.position.maxHeight}px;
  width: ${props => props.position.maxWidth}px;
  height: ${props => props.position.maxHeight}px;
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  transform: ${props => props.position.transform};
  display: flex;
  overflow: hidden;
  pointer-events: all;
`;

export const TextInputDiv = styled.textarea`
  width: 90%;
  background-color: transparent;
  border: none;
  outline: none;
  resize: none;
  padding: 0;
  overflow: hidden;
  white-space: pre;

  &::placeholder {
    color: transparent; // fix for Safari, when there is an empy text, the caret doesn't display
  }
`;
